import { useEffect, useState } from 'react';
import { THEME } from '@/common/styles/theme';

const MOBILE_MEDIA_QUERY = `(max-width: ${THEME.mobileBreakpoint})`;

export const useStudioMobileViewport = () => {
	const [isMobile, setIsMobile] = useState(() => {
		if (typeof window === 'undefined') {
			return false;
		}

		return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
	});

	useEffect(() => {
		const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
		const handleChange = (event) => setIsMobile(event.matches);

		setIsMobile(mediaQuery.matches);
		mediaQuery.addEventListener('change', handleChange);

		return () => mediaQuery.removeEventListener('change', handleChange);
	}, []);

	return isMobile;
};
